/** Formatação e leitura de dados do portal. Nenhuma regra de negócio aqui. */

/** Placeholder do seed para chaves de `configuracao` ainda não definidas (SPEC §12). */
const PLACEHOLDER = /^\[.*definir.*\]$/i;

/** `true` se o valor ainda é o placeholder do seed (D2/D6 — endereço/horário fictícios). */
export function ehPlaceholder(v: string | null | undefined): boolean {
  return !v || PLACEHOLDER.test(v.trim());
}

/** Valor de configuração utilizável, ou `null` se ausente / ainda placeholder (D2/D6). */
export function valorConfig(mapa: Record<string, string>, chave: string): string | null {
  const v = mapa[chave]?.trim();
  if (ehPlaceholder(v)) return null;
  return v ?? null;
}

/** ISO 8601 → `DD/MM` (lista de indicações, UX §5.5). */
export function dataCurta(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** ISO 8601 (ou `YYYY-MM-DD`) → `DD/MM/AAAA`. */
export function dataLonga(iso: string): string {
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(
    2,
    '0',
  )}/${d.getFullYear()}`;
}

/** `true` se `campanhaFim` (YYYY-MM-DD) está a 30 dias ou menos — e ainda não passou. */
export function nosUltimos30Dias(campanhaFim: string | null): boolean {
  if (!campanhaFim) return false;
  const fim = new Date(`${campanhaFim.slice(0, 10)}T23:59:59`);
  if (Number.isNaN(fim.getTime())) return false;
  const agora = Date.now();
  const restante = fim.getTime() - agora;
  return restante > 0 && restante <= 30 * 24 * 60 * 60 * 1000;
}
